export const padToDigits = (num) => {
  return num.toString().padStart(2, '0')
}